import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { validateToken, callApi } from "../../../lib/utils";
import moment from "moment-timezone";
import axios from "axios";
import { useSelector } from "react-redux";
import CustomLoader from "../../GenericComponents/CustomLoader";
import "./UnplannedMedicalVisits.css";
import store from "../../../reducers/store";
import GenericTableFilterBar from "../../GenericComponents/GenericTableFilterBar";
import UnplannedMedicalVisitsHeader from "./UnplannedMedicalVisitsHeader";
import UnplannedMedicalVisitsList from "./UnplannedMedicalVisitsList";
import "../DrillDownPage.css";

function UnplannedMedicalVisits() {
  const pages = useSelector((state) => state?.appstate?.pages);
  const [searchList, setSearchList] = useState([]);
  const [UnplannedMVList, setUnplannedMVList] = useState([]);
  const profileData = useSelector((state) => state?.dashboard);
  const [loading, setLoading] = useState(false);
  const currentPage = useSelector((state) => state?.tableFilter?.currentPage);
  const perPage = useSelector((state) => state?.tableFilter?.perPage);
  const startDate = useSelector((state) => state?.globalFilters?.startDate);
  const endDate = useSelector((state) => state?.globalFilters?.endDate);

  useEffect(() => {
    if (profileData?.profileData?.id) {
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        fetchData();
      });
    }
  }, [perPage, currentPage]);

  const setPagination = (data) => {
    store.dispatch({ type: "SET_PAGINATION_PAGES", payload: { pages: data } });
  };

  const fetchData = () => {
    const visitType = {
      planned: 1,
      unplanned: 2,
    };
    let params = {
      patientId: profileData?.profileData?.id,
      eventType: 9,
      start: startDate,
      end: endDate,
      page: currentPage,
      limit: parseInt(perPage),
      visitType: visitType.unplanned,
    };
    setLoading(true);
    callApi(`/api/patient/events`, params, "POST")
      .then((response) => {
        setUnplannedMVList(response?.data?.data?.medicalVisits);
        setSearchList(response?.data?.data?.medicalVisits);
        setPagination(response?.data?.data?.pagination?.pages);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const filterRecordsBySearchText = (searchText) => {
    let filteredList = [];
    searchList.forEach((list) => {
      let shouldAdd = true;
      if (
        list.visitType.visitType.toUpperCase().search(searchText.toUpperCase()) ===
        -1
      ) {
        shouldAdd = false;
      }

      if (shouldAdd) {
        filteredList.push(list);
      }
    });
    setUnplannedMVList(filteredList);
  };

  const exportFiles = () => {
    let params = {
      start: startDate,
      end: endDate,
      timezone: moment.tz.guess(),
      visitType: 2,
    };
    setLoading(true);

    axios({
      method: "post",
      url: `/api/export/pdf/medical-visits/${profileData?.profileData?.id}`,
      responseType: "blob",
      data: params,
    })
      .then((response) => {
        var filename = "";
        let disposition = null;

        if (Object.keys(response.headers).includes("content-disposition")) {
          disposition = response.headers["content-disposition"];
        } else if (
          Object.keys(response.headers).includes("Content-Disposition")
        ) {
          disposition = response.headers["Content-Disposition"];
        }

        // var disposition = xhr.getResponseHeader('Content-Disposition');
        if (disposition && disposition.indexOf("attachment") !== -1) {
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
          }
        }
        let blobData = response.data;
        setLoading(false);
        fileDownload(filename, blobData);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const fileDownload = (filename, blobData) => {
    var blobURL = window.URL.createObjectURL(blobData);
    var tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute(
      "download",
      filename !== ""
        ? `${filename}`
        : "report.pdf"
    );

    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  };

  return (
    <div className="drilldown-page">
      <CustomLoader loading={loading} />

      <UnplannedMedicalVisitsHeader />
      <GenericTableFilterBar pages={pages} title="" filterRecordsBySearchText={filterRecordsBySearchText} showPdfExportIcon={true}
        pdfExport={() => exportFiles()} />

      < UnplannedMedicalVisitsList currentPage={currentPage} perPage={perPage} UnplannedMVList={UnplannedMVList} />
    </div>
  );
}

export default UnplannedMedicalVisits;
